export const SOLO_STS_TIMELINE_INLINE_CLASS = 'xl:hidden';
export const SOLO_STS_TIMELINE_XL_GRID_LOCATION = 'hidden xl:block xl:col-start-3 xl:col-end-4 xl:row-start-1 xl:row-end-1';
// Embedded Solo (Dashboard Favorites): STS stays in the first column under the
// config at every width, so the TOS panel keeps columns 2-3.
export const SOLO_FOCUS_TOS_PANEL_GRID_LOCATION = 'sm:col-start-2 sm:col-end-4 sm:row-start-1 sm:row-end-1 col-start-1 col-end-1 row-start-2 row-end-2';
